export default "__VITE_PUBLIC_ASSET__edf2ba10__"